// use common.js, so we can consume the config modules in the build flow
module.exports = Object.freeze({
  appName: 'lp-le-management-console',
  appCode: 'mc',
  PRIVILEGES: {
    MC_VIEW_AND_ACCESS: '1857',
    MC_EDIT_AND_SAVE: '1858',
    MC_LPA_SAVE_HIGH_RISK: '1867'
  },
  defaultDialogWidth: '600px',
  COMPONENTS: {
    RADIO: 'radio', // must specify options, which is an array of { displayName: '', value: '' }
    DROPDOWN: 'dropdown', // must specify options, which is an array of { displayName: '', value: '' }
    TEXT: 'text',
    NUMBER: 'number', // same as float - allow floats (fraction)
    INTEGER: 'integer', // only allow integers (whole numbers)
    FLOAT: 'float', // same as number - allow floats (fraction)
    TOGGLE: 'toggle', // can specify enabledValue and disabledValue
  },
  SETTING_TYPES: {
    PROVISION: 'provision',
    SETTINGS: 'settings',
  },
  TOOL_FEATURE_TYPE_NAVIGATION: {
    INTERNAL: "LEInternalNavigation",
    EXTERNAL: "regularUrlNavigation",
    OPEN_MULTI_URL_TAB_INTERVAL: 6500
  },
  useFakeData: false,
  useFakeDataForGetOnly: false,
},);


